import { MultipleLocalStorageKeys } from 'constants/local-storage';

export const UNIT_SYSTEM = {
    metric: 'metric'
};

export const getUnitSystem = () => localStorage.getItem(MultipleLocalStorageKeys.bodyHeightWeightKeys.unitSystem);
